import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';

export const useGetServices = () => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_SERVICES],
    queryFn: API.booking.getServices,
    refetchOnWindowFocus: false
  });

  return {
    data,
    status,
    isLoading,
    isFetching
  };
};

export const useGetKinSimCampaigns = (enabled: boolean = false) => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_ESIM_CAMPAIGNS],
    queryFn: API.service.serviceGetKinSimCampaigns,
    enabled
  });

  return {
    data: data?.data,
    status,
    isLoading,
    isFetching
  };
};

export const useGetKinSimUrls = (service_id: number, enabled: boolean = false) => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_ESIM_URL, service_id],
    queryFn: () => API.service.serviceGetKinSimUrls(service_id),
    enabled
  });

  return {
    data: data?.data,
    status,
    isLoading,
    isFetching
  };
};

export const useGetKinSimCampaignDetails = (campaign_id?: number, enabled: boolean = false) => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_ESIM_CAMPAIGN_DETAILS, campaign_id],
    queryFn: () => API.service.getKinSimCampaignDetails(campaign_id || 0),
    enabled: !!campaign_id && enabled
  });

  return {
    data: data?.data,
    status,
    isLoading,
    isFetching
  };
};
